<template>
    <div class="arabian-export-certificate">
        <div class="certificate-header">
            <div class="certificate-header-logo">
                <p class="certificate-header-logo-text">EXPORT</p>
                <img src="../../../assets/arabian-horse.jpg" alt="arabian-logo" class="arabian-logo-image" />
                <p class="certificate-header-logo-text">CERTIFICATE</p>
            </div>
            <div class="certificate-header-text">
                <div class="certificate-header-text-row">ALL SECTIONS MUST BE COMPLETED IN FULL</div>
                <div class="certificate-header-text-row">Type or use black ink to complete this form</div>
                <div class="certificate-header-text-row">Please include ISO codes of country of birth for subject horse, sire and dam, after their names</div>
            </div>
        </div>
        <div class="certificate-form">
            <div class="certificate-row">
                <div class="certificate-label">COUNTRY OF EXPORT <span class="font-bold ml-1">{{ data?.countryOfExport }}</span></div>
                <div class="certificate-label"> DATE OF EXPORT <span class="font-bold ml-1">{{ data?.dateOfExport }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">NAME <span class="font-bold ml-1">{{ data?.horseName }}</span></div>
                <div class="certificate-label">SEX <span class="font-bold ml-1">{{ data?.horseSex }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">DATE OF BIRTH <span class="font-bold ml-1">{{ data?.dateOfBirth }}</span></div>
                <div class="certificate-label">COLOUR <span class="font-bold ml-1">{{ data?.colour }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">ORIGINAL STUD BOOK REFERENCE <span class="font-bold ml-1">{{ data?.originalStudBookReference }}</span></div>
                <div class="certificate-label">ORIGINAL REGISTRATION NUMBER <span class="font-bold ml-1">{{ data?.originalRegistrationNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">UELN (if issued) <span class="font-bold ml-1">{{ data?.ueln }}</span></div>
                <div class="certificate-label">MICROCHIP NUMBER (if issued) <span class="font-bold ml-1">{{ data?.microchipNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">CURRENT STUD BOOK REFERENCE <span class="font-bold ml-1">{{ data?.currentStudBookReference }}</span></div>
                <div class="certificate-label">CURRENT REGISTRATION NUMBER <span class="font-bold ml-1">{{ data?.currentRegistrationNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Sire <span class="font-bold ml-1">{{ data?.sireName }}</span></div>
                <div class="certificate-subrow">
                    <div class="certificate-label">Date of Birth <span class="font-bold ml-1">{{ data?.sireDateOfBirth }}</span></div>
                    <div class="certificate-label">Colour <span class="font-bold ml-1">{{ data?.sireColour }}</span></div>
                </div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Original Stud Book Reference <span class="font-bold ml-1">{{ data?.sireOriginalStudBookReference }}</span></div>
                <div class="certificate-label">Registration Number <span class="font-bold ml-1">{{ data?.sireOriginalRegistrationNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Current Stud Book Reference <span class="font-bold ml-1">{{ data?.sireCurrentStudBookReference }}</span></div>
                <div class="certificate-label">Current Registration Number <span class="font-bold ml-1">{{ data?.sireCurrentRegistrationNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Dam <span class="font-bold ml-1">{{ data?.damName }}</span></div>
                <div class="certificate-subrow">
                    <div class="certificate-label">Date of Birth <span class="font-bold ml-1">{{ data?.damDateOfBirth }}</span></div>
                    <div class="certificate-label">Colour <span class="font-bold ml-1">{{ data?.damColour }}</span></div>
                </div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Stud Book Reference <span class="font-bold ml-1">{{ data?.damOriginalStudBookReference }}</span></div>
                <div class="certificate-label">Registration Number <span class="font-bold ml-1">{{ data?.damOriginalRegistrationNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Current Stud Book Reference <span class="font-bold ml-1">{{ data?.damCurrentStudBookReference }}</span></div>
                <div class="certificate-label">Current Registration Number <span class="font-bold ml-1">{{ data?.damCurrentRegistrationNumber }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label flex flex-column">Name, Address and Country of Breeder
                    <span class="font-bold">{{ computedText(data?.breederName,data?.breederAddress,data?.breederCountry) }}</span>
                </div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label flex flex-column">
                    Name, Address and Country of the last Recorded Owner (Export Country)
                    <span class="font-bold">{{ computedText(data?.oldOwnerName,data?.oldOwnerAddress,data?.oldOwnerCountry) }}</span>
                </div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label flex flex-column">
                    Name, Address and Country of Owner, Authorised Agent, Purchaser or Leasee (Receiving Country)
                    <span class="font-bold">{{ data?.newOwner }}</span>
                </div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Date Ownership Transfer (if applicable) <span class="font-bold ml-1">{{ data?.dateOwnershipTransfer }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">CERTIFIED BY:</div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">(STUD BOOK AUTHORITY)</div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Name of Registry <span class="font-bold ml-1">{{ data?.registryName }}</span></div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Signature of Official ..............</div>
            </div>
            <div class="certificate-row">
                <div class="certificate-label">Date <span class="font-bold ml-1">{{ todayDate() }}</span></div>
            </div>
        </div>
        <div class="certificate-footer">
            <div class="certificate-row">WAHO Approved 2023</div>
            <div class="certificate-row">Form Continued on Reverse</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ExportArabian",
    data() {
        return {
        };
    },
    props: {
        data: {
            type: Object,
        },
    },
    methods: {
        computedText(part1, part2, part3) {
            const text = [];

            if (part1) text.push(part1);
            if (part2) text.push(part2);
            if (part3) text.push(part3);

            return text.join("; ");
        },
        todayDate() {
            const today = new Date();

            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const year = today.getFullYear();

            return `${day}-${month}-${year}`;
        },
    },
};
</script>

<style scoped lang="scss">
    .arabian-export-certificate {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 26cm;
        .certificate-header {
            &-logo {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 1rem;
                &-text {
                    // width: 190px;
                    font-size: 1.5rem;
                }
            }
            &-text {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-bottom: 0.7rem;
                &-row {
                    text-align: center;
                    &:nth-of-type(1) {
                        font-weight: bold;
                        font-size: .7rem;
                    }
                    &:nth-of-type(2) {
                        font-size: .6rem;
                    }
                    &:nth-of-type(3) {
                        font-weight: bold;
                        font-size: .6rem;
                    }
                }
            }
        }
        .certificate-row {
            display: flex;
            margin-bottom: 0.5rem;
            &:nth-of-type(6) {
                margin-bottom: .7rem !important;
            }
            &:nth-of-type(9) {
                margin-bottom: .7rem !important;
            }
            &:nth-of-type(12) {
                margin-bottom: .7rem !important;
            }
            &:nth-of-type(13) {
                margin-bottom: 2rem !important;
                .certificate-label {
                    width: 100% !important;
                }
            }
            &:nth-of-type(14) {
                margin-bottom: 2rem !important;
                .certificate-label {
                    width: 100% !important;
                }
            }
            &:nth-of-type(15) {
                margin-bottom: 2rem !important;
                .certificate-label {
                    width: 100% !important;
                }
            }
            &:nth-of-type(18) {
                margin-bottom: 1rem !important;
            }
            &:nth-of-type(19) {
                margin-bottom: .7rem !important;
            }
            &:nth-of-type(20) {
                margin-bottom: 2rem !important;
            }
            .certificate-label {
                width: 50%;
                font-size: .7rem;
            }
            .certificate-subrow {
                width: 50%;
                display: flex;
                .certificate-label {
                    width: 50%;
                }
            }
        }
        .certificate-footer {
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: center;
            .certificate-row {
                font-size: .7rem;
                line-height: .7rem;
            }
        }
    }
</style>
